import S_IMG1 from './Images/S-img1.jpg';
import S_IMG2 from './Images/S-img2.jpg';
import S_IMG3 from './Images/S-img3.jpg'; 
import S_IMG4 from './Images/S-img4.jpg';
import S_IMG5 from './Images/S-img5.jpg';
import S_IMG6 from './Images/S-img6.jpg';
import CITR1 from './Images/CITR1.jpg';
import CITR2 from './Images/CITR2.jpg';
import CITR3 from './Images/CITR3.jpg';
import CITR4 from './Images/CITR4.jpg';
import CITR5 from './Images/CITR5.jpg';
import CITR6 from './Images/CITR6.jpg';
const Educatio_desc={
    "Education & Training": {
        id:0,
        title: "Education & Training",
        short_desc: "The Education and Training Programs designed to meet the evolving demands of industry and society.",
        Desc:"The <b>Education and Training Programs</b> designed to meet the evolving demands of industry and society. These programs are structured to blend theoretical knowledge with hands-on experience, fostering innovation, creativity, and technical excellence.The <b>CITR</b> remains committed to nurturing talent and bridging the gap between education and innovation. Through its structured training programs, the Centre continues to build a knowledge-driven community ready to lead in a competitive, technology-centric world.",
        Short_img :S_IMG1,
        big_img:CITR1,
    },
    "Internships": {
        id:1,
        title: "Internships",
        short_desc: "The CITR offers structured Internship Programs designed to provide students and young professionals.",
        Desc:"The <b>CITR</b> offers structured <b>Internship Programs</b> designed to provide students and young professionals with the opportunity to work on real-world projects, collaborate with researchers and industry experts, and develop skills that are essential for today’s innovation-driven economy and enhance their career readiness.The <b>CITR Internship Programs</b> are not just about learning—they’re about innovating, building, and contributing to solutions that matter. Join us and take the first step towards becoming a change-maker in the world of technology and research.",
        Short_img:S_IMG2,
        big_img:CITR2,
    },
    "Seminars/Workshops": {
        id:2,
        title: "Seminars & Workshops",
        short_desc: "The CITR organizes Seminars and Workshops aimed at fostering knowledge exchange, skill development, and industry-academic collaboration. ",
        Desc:"The <b>CITR</b> organizes <b>Seminars and Workshops</b> aimed at fostering knowledge exchange, skill development, and industry-academic collaboration. These programs serve as dynamic platforms for learning, dialogue, opportunities and exposure to emerging technologies and research trends.",
        Short_img:S_IMG3,
        big_img:CITR3,
    },
    "Research & Development Cell": {
        id:3,
        title: "Research & Development Cell",
        short_desc: "The Research & Development Cell under the CITR is a strategic unit dedicated to promoting a strong research culture, fostering interdisciplinary innovation.",
        Desc:"The <b>Research & Development Cell</b> under the <b>CITR</b> is a strategic unit dedicated to promoting a strong research culture, fostering interdisciplinary innovation, and supporting the development of impactful technologies. It serves as a hub for academic and applied research, industrial collaboration, and intellectual property generation.The <b>R&D</b> Cell at <b>CITR</b> is committed to transforming ideas into innovations, and research into societal and industrial value. It is a place where curiosity meets creativity, and knowledge meets action.",
        Short_img:S_IMG4,
        big_img:CITR4,
    },
    "Career Assistance Cell": {
        id:4,
        title: "Career Assistance Cell",
        short_desc: "The R&D Cell at CITR is committed to transforming ideas into innovations, and research into societal and industrial value. It is a place where curiosity meets creativity, and knowledge meets action.",
        Desc:"The <b>Career Assistance Cell</b> under the <b>CITR</b> is dedicated to supporting students in building successful and meaningful careers technology in innovative domains. The Cell acts as a bridge between academic learning and professional development, offering guidance, mentorship, and placement support aligned with current industry needs.",
        Short_img:S_IMG5,
        big_img:CITR5,
    },
    "Career Opportunities Cell": {
        id:5,
        title: "Career Opportunities Cell",
        short_desc: "The Career Opportunities Cell of the CITR serves as a strategic platform to connect talent with opportunity.",
        Desc:"The <b>Career Opportunities Cell</b> of the <b>CITR</b> serves as a strategic platform to connect talent with opportunity. It is committed to helping final year or graduated students to explore diverse career paths available in different parts of the country through this platform and prepare for successful employment or entrepreneurial ventures.",
        Short_img:S_IMG6,
        big_img:CITR6,
    },
}
export default Educatio_desc;